'use strict'

var constants = {
  pageGutter: 10
}

export default constants
